export const siteInfo = {
  name: '满冠体育',
  tagline: '专业体育服务平台',
  description: '满冠体育是专注于体育赛事、运动培训与体育用品的综合服务平台。我们为运动爱好者、专业运动员及体育机构提供一站式解决方案，助力每一位用户实现运动梦想，迈向冠军之路。',
  keywords: '满冠体育,满冠体育赛事服务,满冠体育培训,满冠体育用品,体育综合服务平台,专业运动培训机构,体育赛事组织',
  url: 'https://www.manguansports.com',
  logo: '满冠体育',
  email: 'contact@manguansports.com',
  phone: '400-888-6666',
  address: '北京市朝阳区奥林匹克公园体育中心A座',
  social: {
    wechat: '满冠体育',
    weibo: '@满冠体育官方',
    douyin: '@满冠体育',
  },
};

export const heroSlides = [
  {
    title: '点燃运动激情',
    subtitle: '专业赛事服务，让每一场比赛都成为经典',
    cta: '探索赛事服务',
    link: '/services?tab=events',
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20sports%20stadium%20with%20dramatic%20stadium%20lighting%20at%20sunset%2C%20professional%20athletes%20in%20action%20on%20track%20field%2C%20warm%20golden%20and%20crimson%20tones%2C%20epic%20sports%20photography%20style%2C%20cinematic%20composition%2C%20atmospheric%20fog%2C%20wide%20angle%20shot%2C%20clean%20modern%20aesthetic&width=1600&height=900&seq=manguan-hero-01&orientation=landscape',
  },
  {
    title: '冠军之路从这里开始',
    subtitle: '系统化专业培训，科学训练方案助力突破极限',
    cta: '了解培训课程',
    link: '/services?tab=training',
    image: 'https://readdy.ai/api/search-image?query=Professional%20sports%20training%20facility%20with%20modern%20equipment%2C%20coach%20instructing%20athletes%20in%20bright%20indoor%20gym%2C%20warm%20crimson%20and%20gold%20accent%20lighting%2C%20dynamic%20movement%20captured%2C%20clean%20minimalist%20interior%2C%20motivational%20atmosphere%2C%20editorial%20sports%20photography&width=1600&height=900&seq=manguan-hero-02&orientation=landscape',
  },
  {
    title: '专业装备成就非凡',
    subtitle: '精选优质体育用品，为每一次运动保驾护航',
    cta: '选购体育用品',
    link: '/services?tab=products',
    image: 'https://readdy.ai/api/search-image?query=Premium%20sports%20equipment%20display%20in%20modern%20retail%20setting%2C%20professional%20basketball%20and%20tennis%20gear%20arranged%20artistically%2C%20warm%20golden%20lighting%20with%20crimson%20accents%2C%20minimalist%20product%20photography%20style%2C%20clean%20white%20background%20with%20subtle%20shadows%2C%20premium%20quality%20feel&width=1600&height=900&seq=manguan-hero-03&orientation=landscape',
  },
];

export const serviceCategories = [
  {
    id: 'events',
    name: '体育赛事',
    icon: 'ri-trophy-line',
    description: '专业赛事策划与组织，覆盖田径、球类、水上运动等多个项目，提供从赛事方案、场地布置到现场执行的全流程服务。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20sports%20event%20organization%20scene%2C%20marathon%20race%20starting%20line%20with%20crowd%20of%20runners%2C%20banners%20and%20flags%2C%20bright%20sunny%20day%2C%20energetic%20atmosphere%2C%20warm%20golden%20and%20crimson%20color%20scheme%2C%20professional%20event%20photography%2C%20clean%20composition&width=800&height=600&seq=manguan-service-events&orientation=landscape',
    features: ['赛事策划', '场地布置', '裁判服务', '安全保障', '媒体传播', '志愿者管理'],
  },
  {
    id: 'training',
    name: '运动培训',
    icon: 'ri-run-line',
    description: '汇聚国家级教练团队，提供篮球、足球、游泳、田径等项目的专业培训课程，量身定制科学训练计划。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20sports%20coach%20training%20young%20athletes%20in%20modern%20indoor%20sports%20facility%2C%20basketball%20drills%20session%2C%20natural%20bright%20lighting%2C%20warm%20atmosphere%2C%20clean%20minimalist%20gym%20design%2C%20professional%20sports%20photography%2C%20crimson%20and%20white%20color%20palette&width=800&height=600&seq=manguan-service-training&orientation=landscape',
    features: ['私人教练', '团体课程', '青少年培训', '企业团建', '康复训练', '技术分析'],
  },
  {
    id: 'products',
    name: '体育用品',
    icon: 'ri-shopping-bag-3-line',
    description: '严选国际国内知名品牌体育装备，覆盖跑步、健身、球类、户外等品类，确保每一件产品都经得起专业检验。',
    image: 'https://readdy.ai/api/search-image?query=Premium%20sports%20equipment%20and%20apparel%20beautifully%20arranged%20in%20modern%20retail%20display%2C%20running%20shoes%20basketball%20tennis%20rackets%20yoga%20mats%2C%20warm%20golden%20accent%20lighting%2C%20clean%20minimalist%20white%20background%2C%20professional%20product%20photography%2C%20premium%20aesthetic&width=800&height=600&seq=manguan-service-products&orientation=landscape',
    features: ['跑步装备', '球类器材', '健身器械', '运动服饰', '户外用品', '智能穿戴'],
  },
];

export const featuredEvents = [
  { id: 1, title: '2026城市马拉松挑战赛', date: '2026年10月15日', location: '北京奥体中心', status: '报名中', participants: 3280, image: 'https://readdy.ai/api/search-image?query=City%20marathon%20race%20scene%20with%20thousands%20of%20runners%20on%20urban%20street%2C%20banners%20and%20cheering%20crowds%2C%20bright%20sunny%20day%2C%20energetic%20atmosphere%2C%20warm%20golden%20hour%20lighting%2C%20professional%20event%20photography%2C%20clean%20composition&width=600&height=400&seq=manguan-event-01&orientation=landscape' },
  { id: 2, title: '全国青少年篮球联赛', date: '2026年9月20日', location: '上海体育馆', status: '进行中', participants: 1560, image: 'https://readdy.ai/api/search-image?query=Youth%20basketball%20tournament%20in%20modern%20indoor%20arena%2C%20young%20players%20in%20action%20dribbling%20and%20shooting%2C%20bright%20stadium%20lights%2C%20energetic%20competitive%20atmosphere%2C%20warm%20crimson%20team%20uniforms%2C%20professional%20sports%20photography&width=600&height=400&seq=manguan-event-02&orientation=landscape' },
  { id: 3, title: '全民健身游泳公开赛', date: '2026年11月5日', location: '广州天河体育中心', status: '即将开始', participants: 890, image: 'https://readdy.ai/api/search-image?query=Professional%20swimming%20competition%20in%20olympic%20size%20pool%2C%20swimmers%20in%20action%20diving%20and%20racing%2C%20bright%20indoor%20natatorium%20with%20blue%20water%2C%20spectators%20in%20background%2C%20clean%20professional%20sports%20photography%2C%20dynamic%20composition&width=600&height=400&seq=manguan-event-03&orientation=landscape' },
  { id: 4, title: '京津冀羽毛球团体赛', date: '2026年12月10日', location: '天津奥林匹克中心', status: '报名中', participants: 720, image: 'https://readdy.ai/api/search-image?query=Professional%20badminton%20tournament%20in%20modern%20indoor%20sports%20hall%2C%20players%20in%20intense%20rally%2C%20bright%20court%20lighting%2C%20dynamic%20action%20shot%2C%20warm%20atmosphere%2C%20professional%20sports%20photography%2C%20clean%20composition&width=600&height=400&seq=manguan-event-04&orientation=landscape' },
];

export const trainingPrograms = [
  { id: 1, name: '篮球精英训练营', coach: '张教练 - 前CBA球员', duration: '12周', level: '进阶', price: '¥4,800', age: '12-18岁', image: 'https://readdy.ai/api/search-image?query=Professional%20basketball%20training%20session%20in%20modern%20indoor%20court%2C%20coach%20demonstrating%20technique%20to%20young%20players%2C%20bright%20clean%20gym%2C%20warm%20crimson%20accents%2C%20professional%20sports%20coaching%20photography%2C%20dynamic%20composition&width=600&height=400&seq=manguan-train-01&orientation=landscape' },
  { id: 2, name: '游泳基础培训班', coach: '李教练 - 国家级游泳教练', duration: '8周', level: '入门', price: '¥3,200', age: '6-15岁', image: 'https://readdy.ai/api/search-image?query=Swimming%20coach%20teaching%20children%20in%20indoor%20pool%2C%20kids%20learning%20swimming%20techniques%2C%20bright%20natatorium%20with%20natural%20light%2C%20warm%20atmosphere%2C%20professional%20aquatic%20training%20photography%2C%20clean%20composition&width=600&height=400&seq=manguan-train-02&orientation=landscape' },
  { id: 3, name: '足球青训计划', coach: '王教练 - 亚足联A级教练', duration: '16周', level: '中级', price: '¥5,600', age: '8-16岁', image: 'https://readdy.ai/api/search-image?query=Youth%20soccer%20training%20on%20professional%20grass%20field%2C%20coach%20instructing%20young%20players%20with%20ball%20drills%2C%20bright%20sunny%20day%2C%20green%20field%20contrast%2C%20warm%20golden%20lighting%2C%20professional%20football%20photography%2C%20clean%20composition&width=600&height=400&seq=manguan-train-03&orientation=landscape' },
  { id: 4, name: '体能综合训练课', coach: '刘教练 - 运动科学博士', duration: '6周', level: '全级别', price: '¥2,800', age: '16岁以上', image: 'https://readdy.ai/api/search-image?query=Modern%20fitness%20training%20studio%20with%20professional%20equipment%2C%20personal%20trainer%20coaching%20client%20with%20kettlebells%2C%20bright%20industrial%20style%20gym%2C%20warm%20lighting%2C%20clean%20minimalist%20aesthetic%2C%20professional%20fitness%20photography&width=600&height=400&seq=manguan-train-04&orientation=landscape' },
];

export const featuredProducts = [
  { id: 1, name: '专业竞赛跑鞋', brand: 'Nike AlphaFly', price: '¥2,299', rating: 4.9, sales: 2830, image: 'https://readdy.ai/api/search-image?query=Premium%20professional%20running%20shoes%20displayed%20on%20clean%20white%20surface%2C%20modern%20athletic%20footwear%20design%2C%20warm%20golden%20accent%20lighting%2C%20minimalist%20product%20photography%2C%20crimson%20color%20details%2C%20professional%20ecommerce%20style&width=600&height=400&seq=manguan-prod-01&orientation=landscape' },
  { id: 2, name: '碳纤维羽毛球拍', brand: 'Yonex Astrox', price: '¥1,680', rating: 4.8, sales: 1560, image: 'https://readdy.ai/api/search-image?query=Professional%20badminton%20racket%20displayed%20artistically%20on%20white%20background%2C%20carbon%20fiber%20texture%20visible%2C%20warm%20golden%20rim%20lighting%2C%20minimalist%20product%20photography%2C%20premium%20sports%20equipment%20aesthetic&width=600&height=400&seq=manguan-prod-02&orientation=landscape' },
  { id: 3, name: '智能运动手环', brand: 'Huawei GT Runner', price: '¥1,299', rating: 4.7, sales: 3420, image: 'https://readdy.ai/api/search-image?query=Smart%20fitness%20watch%20displayed%20on%20clean%20white%20surface%2C%20modern%20wearable%20technology%2C%20showing%20heart%20rate%20display%2C%20warm%20golden%20lighting%2C%20minimalist%20tech%20product%20photography%2C%20premium%20aesthetic&width=600&height=400&seq=manguan-prod-03&orientation=landscape' },
  { id: 4, name: '专业篮球', brand: 'Spalding TF-1000', price: '¥599', rating: 4.9, sales: 5100, image: 'https://readdy.ai/api/search-image?query=Professional%20basketball%20on%20clean%20white%20surface%20with%20dramatic%20lighting%2C%20leather%20texture%20visible%2C%20warm%20golden%20and%20crimson%20accents%2C%20minimalist%20product%20photography%2C%20premium%20sports%20equipment%20aesthetic&width=600&height=400&seq=manguan-prod-04&orientation=landscape' },
  { id: 5, name: '瑜伽套装', brand: 'Lululemon Align', price: '¥898', rating: 4.8, sales: 2780, image: 'https://readdy.ai/api/search-image?query=Premium%20yoga%20wear%20set%20folded%20neatly%20on%20natural%20wooden%20surface%2C%20soft%20fabric%20texture%2C%20warm%20natural%20lighting%2C%20minimalist%20product%20photography%2C%20clean%20aesthetic%2C%20athleisure%20style&width=600&height=400&seq=manguan-prod-05&orientation=landscape' },
  { id: 6, name: '竞速游泳镜', brand: 'Speedo Fastskin', price: '¥459', rating: 4.7, sales: 1890, image: 'https://readdy.ai/api/search-image?query=Professional%20swimming%20goggles%20displayed%20on%20clean%20white%20surface%2C%20reflective%20lens%20visible%2C%20water%20droplets%20effect%2C%20warm%20golden%20lighting%2C%20minimalist%20product%20photography%2C%20premium%20aquatic%20equipment%20aesthetic&width=600&height=400&seq=manguan-prod-06&orientation=landscape' },
];

export const articles = [
  {
    id: 1,
    slug: 'marathon-training-guide-2026',
    title: '2026马拉松赛季备战指南：从零基础到完赛的系统训练方案',
    excerpt: '随着秋季马拉松赛季临近，如何科学规划训练计划、合理安排饮食营养、有效预防运动损伤，成为每位跑者关注的焦点。本文为您带来全方位的马拉松备战攻略。',
    category: '赛事指南',
    author: '张教练',
    date: '2026-08-05',
    readTime: '8分钟',
    image: 'https://readdy.ai/api/search-image?query=Marathon%20runners%20training%20on%20scenic%20road%20at%20sunrise%2C%20group%20of%20athletes%20running%20in%20formation%2C%20golden%20morning%20light%2C%20warm%20atmospheric%20photography%2C%20inspirational%20fitness%20scene%2C%20clean%20composition&width=800&height=500&seq=manguan-article-01&orientation=landscape',
    content: '',
  },
  {
    id: 2,
    slug: 'youth-basketball-development',
    title: '青少年篮球发展新趋势：科学训练体系如何塑造未来之星',
    excerpt: '中国青少年篮球培训正经历从传统经验式教学向科学数据化训练的转型。本文将深度解读当前青训体系的最新发展动向与核心理念。',
    category: '培训动态',
    author: '王教练',
    date: '2026-08-02',
    readTime: '6分钟',
    image: 'https://readdy.ai/api/search-image?query=Youth%20basketball%20players%20training%20intensely%20in%20modern%20gym%2C%20coach%20using%20tablet%20for%20data%20analysis%2C%20bright%20indoor%20lighting%2C%20professional%20sports%20photography%2C%20warm%20crimson%20accents%2C%20energetic%20atmosphere&width=800&height=500&seq=manguan-article-02&orientation=landscape',
    content: '',
  },
  {
    id: 3,
    slug: 'sports-equipment-selection',
    title: '专业运动员都在用的装备选购秘籍：2026年最值得投资的体育用品',
    excerpt: '面对琳琅满目的体育用品市场，如何挑选真正适合自己、性价比高的装备？我们邀请多位国家级运动员分享他们的选购经验。',
    category: '装备推荐',
    author: '李明',
    date: '2026-07-28',
    readTime: '10分钟',
    image: 'https://readdy.ai/api/search-image?query=Various%20premium%20sports%20equipment%20beautifully%20arranged%20on%20white%20marble%20surface%2C%20running%20shoes%20rackets%20balls%20watches%2C%20warm%20golden%20lighting%2C%20flat%20lay%20product%20photography%2C%20minimalist%20aesthetic%2C%20professional%20catalog%20style&width=800&height=500&seq=manguan-article-03&orientation=landscape',
    content: '',
  },
  {
    id: 4,
    slug: 'sports-injury-prevention',
    title: '运动损伤预防与康复：每位运动爱好者都应该知道的5个关键原则',
    excerpt: '运动损伤是每一位运动爱好者都可能面临的问题。掌握科学的预防方法和正确的康复技巧，能够帮助你更安全、更持久地享受运动带来的乐趣。',
    category: '运动健康',
    author: '刘博士',
    date: '2026-07-22',
    readTime: '7分钟',
    image: 'https://readdy.ai/api/search-image?query=Professional%20sports%20physiotherapist%20treating%20athlete%20leg%20injury%20in%20modern%20clinic%2C%20medical%20equipment%20visible%2C%20bright%20clean%20environment%2C%20warm%20professional%20atmosphere%2C%20healthcare%20photography%2C%20clinical%20aesthetic&width=800&height=500&seq=manguan-article-04&orientation=landscape',
    content: '',
  },
  {
    id: 5,
    slug: 'swimming-technique-improvement',
    title: '自由泳技术突破：三个核心动作纠正让你游得更快更省力',
    excerpt: '很多游泳爱好者在自由泳中都会遇到瓶颈，速度提不上去、体力消耗快。本文从技术角度出发，详细解析自由泳的三大核心技术要点。',
    category: '技术解析',
    author: '李教练',
    date: '2026-07-18',
    readTime: '9分钟',
    image: 'https://readdy.ai/api/search-image?query=Professional%20swimmer%20demonstrating%20freestyle%20technique%20in%20olympic%20pool%2C%20crystal%20clear%20water%2C%20dynamic%20action%20shot%2C%20bright%20indoor%20natatorium%2C%20warm%20lighting%20reflections%20on%20water%2C%20professional%20aquatic%20photography&width=800&height=500&seq=manguan-article-05&orientation=landscape',
    content: '',
  },
  {
    id: 6,
    slug: 'corporate-sports-teambuilding',
    title: '企业体育团建新玩法：如何用运动凝聚团队力量',
    excerpt: '传统团建模式已经无法满足现代企业的需求。以体育运动为载体的新型团建方式正在成为企业文化建设的新趋势，带来更好的团队协作体验。',
    category: '企业服务',
    author: '赵经理',
    date: '2026-07-12',
    readTime: '5分钟',
    image: 'https://readdy.ai/api/search-image?query=Corporate%20team%20building%20sports%20event%20outdoors%2C%20employees%20participating%20in%20relay%20race%20and%20tug%20of%20war%2C%20sunny%20park%20setting%2C%20joyful%20atmosphere%2C%20warm%20golden%20lighting%2C%20professional%20event%20photography%2C%20clean%20composition&width=800&height=500&seq=manguan-article-06&orientation=landscape',
    content: '',
  },
];

export const faqItems = [
  {
    question: '满冠体育提供哪些赛事服务？',
    answer: '满冠体育提供从赛事策划、场地布置、裁判服务、安全保障到媒体传播的全流程赛事服务。涵盖马拉松、篮球、足球、游泳、羽毛球等多个运动项目，支持企业运动会、校园赛事、社区比赛等各类规模的活动。',
  },
  {
    question: '培训课程适合什么年龄段？',
    answer: '我们的培训课程覆盖全年龄段：青少年课程（6-18岁）注重基础技能培养和运动兴趣激发；成人课程（18岁以上）侧重技术提升和体能强化；还设有专门的企业团建课程和康复训练课程，满足不同人群的需求。',
  },
  {
    question: '如何报名参加赛事或培训课程？',
    answer: '您可以通过官网在线报名、拨打客服热线400-888-6666或关注"满冠体育"微信公众号进行报名。报名成功后，您将收到确认短信和详细的活动/课程安排通知。',
  },
  {
    question: '体育用品支持退换货吗？',
    answer: '我们提供7天无理由退换货服务（不影响二次销售）。如收到商品存在质量问题，请在48小时内联系客服处理，我们将为您免费更换或退款。详细退换货政策请查看商品详情页。',
  },
  {
    question: '满冠体育的教练团队资质如何？',
    answer: '我们的教练团队由国家级退役运动员、体育院校教授和持证专业教练组成，均具备丰富的教学经验和专业资质认证。所有教练定期接受培训和考核，确保教学质量始终处于行业领先水平。',
  },
];

export const stats = [
  { value: '500+', label: '组织赛事', icon: 'ri-trophy-line' },
  { value: '50,000+', label: '培训学员', icon: 'ri-user-star-line' },
  { value: '200+', label: '专业教练', icon: 'ri-team-line' },
  { value: '98%', label: '客户满意度', icon: 'ri-heart-line' },
];

export const partners = [
  '中国田径协会', '中国篮球协会', '国家体育总局', '北京体育大学',
  'Nike', 'Adidas', '李宁', '安踏',
];

export const aboutInfo = {
  intro: '满冠体育成立于2015年，总部位于北京，是国内领先的体育综合服务平台。公司以"让每个人都享受运动的力量"为使命，致力于通过专业的赛事服务、科学的运动培训和优质的体育用品，为每一位运动爱好者创造卓越的运动体验。',
  vision: '成为中国最具影响力的体育综合服务平台，让运动改变生活，让每个人都能在运动中找到自信与力量。',
  mission: '通过专业、创新、贴心的体育服务，助力每一位用户实现运动梦想，迈向属于自己的冠军之路。',
  values: [
    { title: '专业至上', desc: '汇聚行业顶尖人才，以专业能力创造价值' },
    { title: '用户为本', desc: '始终从用户需求出发，提供贴心服务体验' },
    { title: '创新驱动', desc: '拥抱科技变革，持续优化产品与服务' },
    { title: '合作共赢', desc: '与合作伙伴携手共进，共创体育产业未来' },
  ],
  milestones: [
    { year: '2015', event: '满冠体育在北京成立，专注体育赛事服务' },
    { year: '2017', event: '运动培训业务上线，签约100+专业教练' },
    { year: '2019', event: '体育用品商城正式运营，合作品牌超过50家' },
    { year: '2020', event: '线上培训平台推出，服务覆盖全国30+城市' },
    { year: '2022', event: '累计服务学员突破30000人，组织赛事超过300场' },
    { year: '2024', event: '获得"中国体育产业创新企业"称号' },
    { year: '2025', event: '品牌全面升级，打造一站式体育综合服务生态' },
  ],
  honors: [
    '中国体育产业创新企业（2024）',
    '全国青少年体育培训示范单位',
    'ISO 9001质量管理体系认证',
    '中国田径协会战略合作伙伴',
    '北京市体育产业重点扶持企业',
    '消费者最信赖体育品牌（2025）',
  ],
};

export const contactInfo = {
  address: '北京市朝阳区奥林匹克公园体育中心A座',
  phone: '400-888-6666',
  email: 'contact@manguansports.com',
  workingHours: '周一至周五 9:00-18:00',
  wechat: '满冠体育',
  weibo: '@满冠体育官方',
  douyin: '@满冠体育',
};